export default __webpack_public_path__ + "static/media/Vijayavani5.4a8c901d.png";